module.exports = __webpack_public_path__ + "static/media/butto online.56a43cd8.png";